<template>
  <div class="overlay">
    <div class="form-wrapper">
      <a href="http://piknik.cc" target="_blank">
        <v-img
          class="logo mb-8"
          max-width="100px"
          src="../assets/piknik-logo-white.svg"
          alt="Piknik"
        />
      </a>
      <h2 class="white--text mb-2">{{ $t("registerTitle") }}</h2>
      <p
        :class="
          $vuetify.breakpoint.xs ? 'white--text mb-4' : 'white--text mb-8'
        "
      >
        {{ $t("registerDescription") }}
      </p>
      <v-form ref="form" v-model="valid">
        <v-stepper v-model="step" elevation="0" dark>
          <v-stepper-header elevation="0">
            <v-stepper-step
              :complete="step > 1"
              step="1"
              :class="$vuetify.breakpoint.xs ? 'pl-0' : null"
            >
              {{ $t("enterEmail") }}
            </v-stepper-step>
            <v-divider class="d-none d-sm-block"></v-divider>
            <v-stepper-step :complete="step > 2" step="2">
              {{ $t("enterMobile") }}
            </v-stepper-step>
            <v-divider class="d-none d-sm-block"></v-divider>
            <v-stepper-step
              :complete="step > 3"
              step="3"
              :class="$vuetify.breakpoint.xs ? 'pr-0' : null"
            >
              {{ $t("createStrongPassword") }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-content
            step="1"
            :class="$vuetify.breakpoint.xs ? 'px-0' : null"
          >
            <v-text-field
              dark
              v-model="email"
              :rules="[rules.required, rules.email]"
              :label="`${$t('email')} *`"
              type="email"
              :append-icon="isEmailValid ? 'mdi-arrow-right-circle' : ''"
              @click:append="isEmailValid ? submitEmail(email) : (email = '')"
              rounded
              dense
              filled
            >
            </v-text-field>
          </v-stepper-content>

          <v-stepper-content
            step="2"
            :class="$vuetify.breakpoint.xs ? 'px-0' : null"
          >
            <v-text-field
              dark
              v-model="mobile"
              :label="$t('mobile')"
              append-icon="mdi-arrow-right-circle"
              @click:append="step++"
              rounded
              dense
              filled
            >
            </v-text-field>
          </v-stepper-content>

          <v-stepper-content
            step="3"
            :class="$vuetify.breakpoint.xs ? 'px-0' : null"
          >
            <v-text-field
              class="d-sm-none"
              dark
              v-model="email"
              :label="`${$t('email')} *`"
              type="email"
              append-icon="mdi-pencil"
              @click:append="step = 1"
              rounded
              dense
              filled
              readonly
            >
            </v-text-field>
            <v-text-field
              v-if="mobile"
              class="d-sm-none"
              dark
              v-model="mobile"
              :label="$t('mobile')"
              append-icon="mdi-pencil"
              @click:append="step = 2"
              rounded
              dense
              filled
              readonly
            >
            </v-text-field>
            <v-text-field
              dark
              v-model="password1"
              :rules="[rules.required, rules.min, rules.max, rules.password]"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1"
              :type="show1 ? 'text' : 'password'"
              :label="`${$t('password')} *`"
              rounded
              dense
              filled
            ></v-text-field>
            <!-- <v-text-field
              dark
              v-model="password2"
              :rules="[
                rules.required,
                rules.min,
                rules.max,
                rules.password,
                checkSamePasswords,
              ]"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2"
              :type="show2 ? 'text' : 'password'"
              :label="`${$t('passwordAgain')} *`"
              rounded
              dense
              filled
            ></v-text-field> -->
          </v-stepper-content>
        </v-stepper>

        <v-btn
          v-if="step == 1"
          v-on:click="submitEmail(email)"
          dark
          color="white"
          depressed
          rounded
          :disabled="!isEmailValid"
          >{{ $t("continue") }}</v-btn
        >
        <v-btn
          v-if="step == 2"
          v-on:click="step++"
          dark
          color="white"
          depressed
          rounded
          >{{ mobile ? $t("continue") : $t("skip") }}</v-btn
        >
        <v-btn
          v-if="step == 3"
          v-on:click="register"
          dark
          color="white"
          depressed
          rounded
          :disabled="!valid || snackbar"
          :loading="loading"
          >{{ $t("register") }}</v-btn
        >
        <router-link
          v-if="step === 1"
          :class="
            $vuetify.breakpoint.xs
              ? 'caption white--text'
              : 'caption white--text ml-2'
          "
          style="text-decoration: none"
          to="/login"
          >{{ $t("alreadyHaveAnAccount") }}</router-link
        >
      </v-form>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackbarText }}
      <v-btn text small rounded @click="reload()" color="white">{{
        $t("tryAgain")
      }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data() {
    return {
      drawer: null,
      step: 1,
      valid: true,
      rules: {
        required: (value) => !!value || this.$t("requiredField"),
        min: (v) => v.length >= 8 || this.$t("minChars", { chars: 8 }),
        max: (v) => v.length <= 48 || this.$t("maxChars", { chars: 48 }),
        email: (v) => /.+@.+\..+/.test(v) || this.$t("emailMustBeCorrect"),
        password: (v) =>
          /^(?=.*([A-Z]){1,})(?=.*[0-9]{1,})(?=.*[a-z]{1,}).{8,48}$/.test(v) ||
          this.$t("passwordRegex"),
      },
      email: "",
      mobile: "",
      show1: false,
      password1: "",
      show2: false,
      password2: "",
      loading: false,
      snackbar: false,
      snackbarText: this.$t("errorDuringRegistration"),
      timeout: 0,
    };
  },
  created() {
    const email = this.$route.query.email;
    if (/.+@.+\..+/.test(email)) {
      this.email = email;
      this.submitEmail(this.email);
    }
  },
  computed: {
    isEmailValid: function () {
      return /.+@.+\..+/.test(this.email);
    },
    checkSamePasswords: function () {
      return (
        this.password1 === this.password2 || this.$t("passwordsDoNotMatch")
      );
    },
  },
  methods: {
    submitEmail: function (email) {
      this.step++;

      const formData = new FormData();
      const params = new URLSearchParams(window.location.search);

      formData.append("email", email);
      formData.append("referrer", params.get("referrer") || "piknik");
      formData.append("campaignId", params.get("campaignId"));
      formData.append("adsetId", params.get("adsetId"));
      formData.append("adId", params.get("adId"));

      const request = new XMLHttpRequest();
      request.open(
        "POST",
        "https://script.google.com/macros/s/AKfycbzujzRk7acMcYoiszJHrvReSwIWB9ZRPfbV3jCIDbTeix29ToXXtoDVvyK3TPyp-D6LTw/exec"
      );
      request.send(formData);

      try {
        gtag("event", "sign_up_email_submit");
        fbq("trackCustom", "SignUpEmailSubmit");
      } catch (e) {
        console.log("Tracking disabled");
      }
    },
    register: function () {
      this.loading = true;
      const params = new URLSearchParams(window.location.search);
      const data = {
        email: this.email,
        password: this.password1,
        info: { mobile: this.mobile },
        referrer: params.get("referrer") || "piknik",
      };

      this.$store
        .dispatch("register", data)
        .then(() => {
          try {
            gtag("event", "sign_up");
            fbq("trackCustom", "SignUp");
            fbq("track", "CompleteRegistration");
          } catch (e) {
            console.log("Tracking disabled");
          }

          this.loading = false;
          this.$router.push("/create");
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.snackbar = true;
        });
    },
    reload() {
      this.step = 1;
      this.email = "";
      this.password1 = "";
      this.password2 = "";
      this.snackbar = false;
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #007bff;
  z-index: 10;
  display: flex;
  align-items: center;
  text-align: center;
}

.form-wrapper {
  width: 700px;
  height: auto;
  margin: 0 auto;
}

.form-wrapper .logo {
  margin: 0 auto;
}

.form-wrapper .v-stepper {
  background: none;
}

.form-wrapper .v-stepper .v-stepper__header {
  box-shadow: none;
}

.form-wrapper .v-stepper .v-stepper__content {
  padding-top: 16px;
  padding-bottom: 8px;
}

@media (max-width: 600px) {
  .form-wrapper {
    padding: 32px;
  }
  .form-wrapper .v-stepper .v-stepper__content {
    padding-top: 0;
    padding-bottom: 0;
  }
}

/deep/ .v-input__slot {
  background: rgba(255, 255, 255, 0.2) !important;
}

/deep/ .v-btn {
  color: #007bff !important;
}

/deep/ .v-application .error--text {
  color: black !important;
  caret-color: black !important;
}

@media only screen and (max-width: 959px) {
  /deep/
    .v-stepper:not(.v-stepper--vertical)
    .v-stepper__step.v-stepper__step--active
    .v-stepper__label {
    display: flex;
    margin-left: 8px;
  }

  /deep/
    .v-stepper:not(.v-stepper--vertical)
    .v-stepper__step.v-stepper__step--active {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media only screen and (max-width: 599px) {
  .overlay {
    overflow-y: scroll;
    text-align: start;
    align-items: flex-start;
    padding-top: 32px;
  }

  .overlay::-webkit-scrollbar {
    display: none;
  }

  .overlay {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .form-wrapper {
    width: 100%;
  }

  .form-wrapper .logo {
    margin: 0;
  }

  /deep/ .v-stepper:not(.v-stepper--vertical) .v-stepper__step {
    padding-left: 8px;
    padding-right: 8px;
  }

  .form-wrapper /deep/ .v-btn {
    width: 100%;
    margin-bottom: 12px;
  }
}
</style>